"use client";

import { ReactNode } from "react";
import { GoogleTagManager } from "@next/third-parties/google";

import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import initTranslations from "@/app/i18n";

import { StoreUtms } from "@/components/StoreUtms/StoreUtms";
import { SEO } from "@/components/SEO";
import { HistoryEvent } from "@/components/HistoryEvent";

import { LayoutProvider } from "@/contexts/LayoutContext";
import { UserProvider } from "@/contexts/UserContext";
import { ModalProvider } from "@/contexts/ModalContext";
import { GlobalProvider } from "@/contexts/GlobalContext/GlobalContext";
import { LoadingBarProvider } from "@/contexts/LoadingBarContext/LoadingBarContext";
import { QREditorProvider } from "@/contexts/QREditorContext";


import { fonts } from "../../public/fonts/fonts";
import DatadogInit from "@/services/DatadogService/DatadogService";
import { TranslationsProvider } from "@/hocs/TranslationsProvider";

export const LayoutWrapper = async ({
  children,
  lang,
  genericErrors,
  modalData,
}: {
  children: ReactNode;
  lang?: string;
  genericErrors: any;
  modalData: any;
}) => {
  const { resources } = await initTranslations(lang, ["generic-errors"]);
  const fontClasses = Object.values(fonts).map(font => font.variable).join(' ');


  return (
    <html
      lang={lang || "en"}
      className={fontClasses}
    >
      {process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID && (
        <GoogleTagManager
          gtmId={process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}
        />
      )}
      <SEO />
      <StoreUtms />
      <HistoryEvent />
      <DatadogInit />
      <body>
        <TranslationsProvider
          locale={lang || "en"}
          resources={resources}
          namespaces={["generic-errors"]}
        >
          <GoogleOAuthProvider
            clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || ""}
          >
            <GlobalProvider>
              <LayoutProvider
                modalData={modalData}
                genericErrors={genericErrors}
              >
                <UserProvider>
                  <QREditorProvider>
                    <LoadingBarProvider>
                      <ModalProvider>{children}</ModalProvider>
                    </LoadingBarProvider>
                  </QREditorProvider>
                </UserProvider>
              </LayoutProvider>
            </GlobalProvider>
          </GoogleOAuthProvider>
          <Toaster />
        </TranslationsProvider>
      </body>
    </html>
  );
};
